import { render, staticRenderFns } from "./CamaraEnVivo.vue?vue&type=template&id=96d17212&scoped=true&"
import script from "./CamaraEnVivo.vue?vue&type=script&lang=ts&"
export * from "./CamaraEnVivo.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraEnVivo.vue?vue&type=style&index=0&id=96d17212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d17212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('96d17212', component.options)
    } else {
      api.reload('96d17212', component.options)
    }
    module.hot.accept("./CamaraEnVivo.vue?vue&type=template&id=96d17212&scoped=true&", function () {
      api.rerender('96d17212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/EnVivo/CamaraEnVivo.vue"
export default component.exports